import { Position } from '@xyflow/react';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function PromptNode({
  id,
  data = {
    description: '',
    content: ''
  },
  onEditNode,
  onDeleteNode
}) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="speaker_notes"
      nodeData={data}
      color="warning"
      handleConf={[
        { type: 'source', position: Position.Bottom, style: { backgroundColor: 'orange' } }
      ]}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={0} sx={{ p: 1, width: '280px' }}>
        {data?.description && (
          <CompactNodeField
            label={msg({ id: 'field.description.label', defaultMessage: 'Description' })}
            value={data?.description || '-'}
          />
        )}

        <CompactNodeField
          label={msg({ id: 'field.content.label', defaultMessage: 'Content' })}
          value={data?.content || '-'}
          shrink
        />
      </Stack>
    </BaseNode>
  );
}

PromptNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.string
  }),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
